import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { HeaderGlobalUserProfileComponent } from '@cdx/ngx-authentication';
import { HeaderComponent, HeaderGlobalComponent } from '@cdx/ngx-branding';

import { CustomBreadcrumbModule } from '../breadcrumb/breadcrumb.module';
import { PreferencesModule } from '../preferences/preferences.module';

import { AdminLinkComponent } from './admin-link/admin-link.component';
import { ClarivateHeaderComponent } from './clarivate-header/clarivate-header.component';

@NgModule({
  declarations: [ClarivateHeaderComponent, AdminLinkComponent],
  exports: [ClarivateHeaderComponent],
  imports: [
    CommonModule,
    CustomBreadcrumbModule,
    HeaderComponent,
    HeaderGlobalComponent,
    MatIconModule,
    MatMenuModule,
    MatTabsModule,
    RouterModule,
    PreferencesModule,
    MatButtonModule,
    MatTooltipModule,
    HeaderGlobalUserProfileComponent,
  ],
})
export class OrderManagementHeaderModule {}
